import PaginationButtons from './Buttons';

export default PaginationButtons;
export { PaginationButtons };
